import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';

type FormElemWrapperProps = {
  isError?: boolean;
  wrapperTag?: keyof JSX.IntrinsicElements;
  className?: string;
  slots?: {
    fieldLabel?: React.ReactNode;
    fieldDescription?: React.ReactNode;
    description?: React.ReactNode;
    tooltip?: React.ReactNode; // Content for the tooltip
    error?: React.ReactNode; // Error message
    hint?: React.ReactNode; // Hint text
  };
};

const FormElemWrapper: React.FC<PropsWithChildren<FormElemWrapperProps>> = ({
  isError = false,
  wrapperTag = 'label',
  className,
  slots = {},
  children,
}) => {
  const WrapperTag = wrapperTag; // Dynamically determine wrapper tag

  return (
    <div
      className={classNames('background-to-change form-element', className, {
        'form-element--error': isError,
      })}
    >
      <WrapperTag className="form-element__wrapper" tabIndex={-1}>
        <span
          className={classNames('form-element__label form-label d-block', {
            'mb-0': !slots.fieldLabel,
          })}
        >
          {slots.fieldLabel}
          {slots.fieldDescription}
          {slots.description}
          {slots.tooltip && (
            <Tooltip>
              <span className="hint-text text-grey">{slots.tooltip}</span>
            </Tooltip>
          )}
        </span>
        {children}
      </WrapperTag>
      {(isError && slots.error) || slots.hint ? (
        <div className="form-element__hints">
          {isError && (
            <span className="form-element__error field-error-text text-error-400">
              {slots.error}
            </span>
          )}
          {slots.hint && <span className="form-element__hint field-hint">{slots.hint}</span>}
        </div>
      ) : null}
    </div>
  );
};

const Tooltip: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <div className="tooltip">{children}</div>
);

export default FormElemWrapper;
